import React, { useEffect, useMemo, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import routes from '@routes/routes'
import Tag from '@utils/Tag'
import { buscarDocumentos } from '@store/refinanciamento/documentos/actions'
import {
  getBiometricActiveRequest,
  getUseNewProvidersRequest,
  seedRequest,
} from '@store/biometria/actions'
import { ApplicationState } from '@store/types'
import {
  setSolicitarContratacaoOrigin,
  setBottomsheetOrigin,
} from '@store/refinanciamento/simulacao/actions'
import { BridgeService } from '@services/bridge'
import { useTrackingRefin } from '@hooks'
import { StepRefin } from '@utils/enums'

import CarregamentoLayout from './Layout'
import { enumLoading, loadingSteps, LoadingStep } from './utils'

const CarregamentoDadosContratacao: React.FC = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useTrackingRefin(StepRefin.CARREGAMENTO_FORMALIZACAO)

  const [currentLoadingStep, setCurrentLoadingStep] = useState<LoadingStep>(enumLoading.initial)
  const isApp = useSelector((state: ApplicationState) => state.ui.navigation.isApp)
  const { convenioCodigo } = useSelector(
    (state: ApplicationState) => state.refinanciamento.contratos,
  )

  const lembreteKey = 'lembreteCarregamento2Count'

  useEffect(() => {
    const saved = localStorage.getItem(lembreteKey)
    const currentCount = saved ? Number(saved) : 0
    const newCount = currentCount + 1
    localStorage.setItem(lembreteKey, String(newCount))
    BridgeService.tac({
      name: 'carregamento_dados',
      actions: ['confirmar_contratacao'],
    })
  }, [lembreteKey])

  const lembrete = useMemo(
    () =>
      currentLoadingStep === enumLoading.initial || currentLoadingStep === enumLoading.secondStep
        ? 'Lembre-se: o Inter não trabalha com intermediários'
        : 'Lembre-se: não solicitamos a devolução do valor depositado',
    [currentLoadingStep],
  )

  useEffect(() => {
    if (isApp) {
      Tag.enviarTagueamentoApp({
        screen: 'clt:refin:loading',
        ref_type: '',
        content_action: 'Dado carregado',
        action_id: 'Carregamento de dados',
        section: 'loading',
        sub_section: '',
        step: '',
        scenario: 'Carregamento de dados',
        ref_figma: '2',
      })
    } else {
      Tag.enviarTagueamentoWeb({
        element_action: 'page_loaded',
        element_name: 'Carregamento de dados',
        c_page: window.location.href,
        redirect_url: routes.STATUS_DOCUMENTO,
        section_name: 'payrollloan:refin:upload',
        section: 'upload',
        sub_section: '',
        step: '',
        scenario: 'Carregamento de dados',
      })
    }
  }, [isApp])

  useEffect(() => {
    if (convenioCodigo) {
      dispatch(
        getUseNewProvidersRequest({
          covenantId: String(convenioCodigo),
          onUseNewProviders: () =>
            dispatch(
              getBiometricActiveRequest({
                onBiometricIdCloud: () => {
                  dispatch(seedRequest())
                },
              }),
            ),
        }),
      )
    }
  }, [dispatch, convenioCodigo])

  useEffect(() => {
    dispatch(setSolicitarContratacaoOrigin(false))
    dispatch(setBottomsheetOrigin(false))

    const timers = loadingSteps.map(({ step, delay }) =>
      setTimeout(() => setCurrentLoadingStep(step), delay),
    )

    const finalTimeout = setTimeout(() => {
      BridgeService.tic({
        name: 'btn_carregamento_dados',
        action: 'buscar_documentos',
      })

      dispatch(
        buscarDocumentos({
          callback: () => {
            navigate(routes.STATUS_DOCUMENTO)
          },
          callbackError: () => {
            navigate(routes.ERRO, {
              state: { step: 'carregamento-dados-2' },
            })
          },
        }),
      )
    }, 11000)

    return () => {
      timers.forEach(clearTimeout)
      clearTimeout(finalTimeout)
    }
  }, [dispatch, navigate])

  return (
    <CarregamentoLayout
      lembrete={lembrete}
      size={currentLoadingStep.size}
      backgroundColor={currentLoadingStep.bgColor}
    />
  )
}

export default CarregamentoDadosContratacao
